import React, { useEffect, useState } from 'react'
import { apiPut, Get_Api } from '../ApiUrls';
import { toast } from 'react-toastify';

function UpdateAvailableForModal({
    show,
    onClose,
    GetHostessProfile,
    HostessProfile
}) {
    const [IsUploading, setIsUploading] = useState(false);
    const [AllAvailable, setAllAvailable] = useState([]);
    const [AllHobby, setAllHobby] = useState([]);
    const [AvailableFor, setAvailableFor] = useState([]);
    const [PersonalityorHobbies, setPersonalityorHobbies] = useState([]);

    useEffect(() => {
        if (HostessProfile) {
            setAvailableFor(HostessProfile.AvailableFor || []);
            setPersonalityorHobbies(HostessProfile.PersonalityorHobbies || []);
        }
    }, [HostessProfile]);

    const GetAvailableFor = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api(`api/admin/GetAllAvailableFor`);
            setAllAvailable(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.log(error);
        }
    };

    const GetallHobby = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api(`api/admin/GetAllHobby`);
            setAllHobby(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        GetAvailableFor();
        GetallHobby();
    }, []);

    const handleSelection = (name, type) => {
        if (type === "AvailableFor") {
            setAvailableFor((prev) =>
                prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
            );
        } else if (type === "Hobby") {
            setPersonalityorHobbies((prev) =>
                prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
            );
        }
    };



    const UpdateHostess = async () => {
        if (AvailableFor.length === 0) {
            toast.error("AvailableFor is required!");
            return;
        }
        if (PersonalityorHobbies.length === 0) {
            toast.error("Personality or Hobbies is required!");
            return;
        }
        try {
            setIsUploading(true)
            let data = { AvailableFor, PersonalityorHobbies, };
            const response = await apiPut(`api/hostess/UpdateHostess`, data);
            toast.success(response?.message);
            setIsUploading(false)
            onClose();
            GetHostessProfile()
        } catch (error) {
            setIsUploading(false)
            toast.error(error?.response?.data?.message);
            console.log(error);
        }
    };

    if (!show) return null;
    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h2>Update About</h2>
                <br />
                <br />
                <div className="AvailableFor">
                    <h3>Available For</h3>
                    <br />
                    <div className="ModelPhoto-div">
                        {AllAvailable?.map((item) => (
                            <div
                                className={`ModelPhoto ${AvailableFor?.includes(item?.Name) ? 'selected' : ''}`}
                                key={item?._id}
                                onClick={() => handleSelection(item?.Name, "AvailableFor")}
                            >
                                <img src={item?.Image} alt={item?.Name} />
                                <h3>{item?.Name}</h3>
                            </div>
                        ))}
                    </div>
                </div>
                <br />
                <div className="AvailableFor">
                    <h3>Personalities & Hobbies</h3>
                    <br />
                    <div className="ModelPhoto-div">
                        {AllHobby?.map((item) => (
                            <div
                                className={`ModelPhoto ${PersonalityorHobbies?.includes(item?.Name) ? 'selected' : ''}`}
                                key={item?._id}
                                onClick={() => handleSelection(item?.Name, "Hobby")}
                            >
                                <h3>{item?.Name}</h3>
                            </div>
                        ))}
                    </div>
                </div>
                <br />
                <div className='center' style={{gap:20}}>
                    <button onClick={UpdateHostess} disabled={IsUploading}>
                        {IsUploading ? 'Uploading...' : 'Update'}
                    </button>
                    <button onClick={() => { onClose() }}>Close</button>
                </div>
            </div>
        </div>
    )
}

export default UpdateAvailableForModal